type IdleCallbackHandle = number;

type IdleWindow = Window & {
  requestIdleCallback?: (
    callback: () => void,
    options?: { timeout?: number }
  ) => IdleCallbackHandle;
  cancelIdleCallback?: (handle: IdleCallbackHandle) => void;
};

export const runAfterIdle = (
  callback: () => void,
  timeout = 2000
): (() => void) => {
  if (typeof window === 'undefined') {
    callback();
    return () => {};
  }

  const idleWindow = window as IdleWindow;
  let isCancelled = false;
  let timeoutHandle: number | null = null;
  let idleHandle: IdleCallbackHandle | null = null;

  const run = () => {
    if (isCancelled) return;
    callback();
  };

  if (typeof idleWindow.requestIdleCallback === 'function') {
    idleHandle = idleWindow.requestIdleCallback(run, { timeout });
  } else {
    timeoutHandle = window.setTimeout(run, timeout);
  }

  return () => {
    isCancelled = true;
    if (
      idleHandle !== null &&
      typeof idleWindow.cancelIdleCallback === 'function'
    ) {
      idleWindow.cancelIdleCallback(idleHandle);
    }
    if (timeoutHandle !== null) {
      window.clearTimeout(timeoutHandle);
    }
  };
};
